let baseUrl = '';
// let routerMode = 'history';
let DEBUG = false;
let cancelHTTP = [];//取消请求头设置；
if (process.env.NODE_ENV == 'development') {//开发环境
   // baseUrl = "/ucenter";
   DEBUG = true;
}else{
   // 测试环境  /其他环境
   // baseUrl = "/";
   DEBUG = false;
}

export{
   baseUrl,
   routerMode,
   DEBUG,
   ROLE,
   cancelHTTP
}



// WEBPACK FOOTER //
// ./src/utils/env.js